import { FIELD__base } from '../_fields/_base/FIELD__base';
import { INVOCATION__base } from '../_invocations/_base/INVOCATION__base';
import { DTO_GRAPH__edge_autoconnect_info } from './DTO_GRAPH__edge_autoconnect_info';

export class DTO_GRAPH__edge_autoconnect_info_list<T_invocation extends INVOCATION__base> {
  /*
   * FIELDS
   */
  items: DTO_GRAPH__edge_autoconnect_info<T_invocation>[] = [];

  invocation_type!: new () => T_invocation;

  create_only_one_connection: boolean;
  connect_only_if_no_enabled_edges: boolean;

  /*
   * METHODS
   */
  constructor() {
    this.items = [];
    this.create_only_one_connection = true;
    this.connect_only_if_no_enabled_edges = true;
  }

  add<T extends FIELD__base>(field_from: T, names: (keyof T_invocation)[]) {
    let item = new DTO_GRAPH__edge_autoconnect_info<T_invocation>();
    item.field_this = field_from;
    item.field_other_names = names;

    this.items.push(item);
  }
}
